import React, { FC, useEffect, useState } from 'react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { KeyBoard } from '@cps'
import './index.scss'

interface IProps {
  resolve?: (amount: number) => void;
  reject?: () => void;
}

const CustomTipModal: FC<IProps> = ({ resolve, reject }) => {
  const [amountStr, setAmountStr] = useState<string>('0.00')
  const [amount, setAmount] = useState<number>(0)

  useEffect(() => {
    try {
      const amount = parseFloat(amountStr)
      if (amount < 10000) {
        setAmount(amount)
      } else {
        setAmountStr('9999.99')
      }
    } catch {}
  }, [amountStr])

  const canSubmit = amount >= 0

  const submit = () => {
    resolve && resolve(amount)
  }

  return (
    <IonModal
      isOpen
      cssClass='custom-tip-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='custom-tip-header'>
          <span>{i18n.t('pay.customTip')}</span>
          <i className='iconfont icon-close' data-cypid='customTipModalClose' onClick={reject} />
        </div>
      </IonHeader>
      <IonContent>
        <div className='amount'>{amountStr}</div>
        <KeyBoard value={amountStr} onChange={setAmountStr} />
      </IonContent>
      <IonFooter className='custom-tip-footer'>
        <button className='cancel-button' data-cypid='customTipModalClose' onClick={reject}>{i18n.t('common.cancel')}</button>
        <button className='submit-button' data-cypid='customTipModalConfirm' disabled={!canSubmit} onClick={submit}>{i18n.t('common.ok')}</button>
      </IonFooter>
    </IonModal>
  )
}

export default CustomTipModal
